import React from 'react';
import { getAllOrdersService } from '../../services/ordersServices.js';
import { useNavigate } from 'react-router-dom';
import Status from './additionFields/Status.jsx';
import { convertDateToJalaali } from '../../utils/convertDate.js';
import OrderActions from './additionFields/OrderActions.jsx';
import { Button } from '@mui/material';
import DataTablePagination from '../../components/Table/DataTablePagination.jsx';
import IsPaid from '../Payments/additionFields/isPaid.jsx';

const options = [
    {
        value: "",
        text: "همه"
    },
    {
        value: "o",
        text: "جاری"
    },
    {
        value: "d",
        text: "تکمیل شده"
    },
    {
        value: "c",
        text: "لغو شده"
    },
];

const Orders = () => {
    const navigate = useNavigate();
    const { userRole } = localStorage.getItem("cncToken") ? JSON.parse(localStorage.getItem("cncToken")) : navigate("/auth/login");

    const ordersCols = [
        {
            field: "code",
            text: "کد سفارش"
        },
        {
            field: null,
            text: "وضعیت",
            element: (rowData) => <Status rowData={rowData} />
        },
        {
            field: null,
            text: "وضعیت پرداخت",
            element: (rowData) => <IsPaid rowData={rowData} />
        },
        {
            field: null,
            text: "تاریخ ثبت سفارش",
            element: (rowData) => <span>{convertDateToJalaali(rowData.order_date)}</span>
        },
        {
            field: null,
            text: "مبلغ پرداختی",
            element: (rowData) => <span>{rowData.payment_price ? rowData.payment_price.toLocaleString() : ""}</span>
        },
        {
            field: null,
            text: "جزئیات کاربر",
            element: (rowData) => {
                return (
                    <Button variant="contained" color="success"
                        onClick={() => navigate("/orders/user", {
                            state: {
                                ...rowData,
                                customer: rowData.user
                            }
                        })}
                    >
                        اطلاعات کاربر
                    </Button>
                )
            }
        },
        {
            field: null,
            text: "مشاهده فاکتور",
            element: (rowData) => {
                return (
                    <Button variant="contained" color="success"
                        onClick={() =>
                            window.open(
                            `https://app.wisercam.com/PrintFactor/${rowData.code}`
                            )
                        }
                    >
                        مشاهده فاکتور
                    </Button>
                )
            }
        },
        {
            field: null,
            text: "جزئیات سفارش",
            element: (rowData) => {
                return (
                    <Button variant="contained" color="success"
                        onClick={() => navigate("/orders/order", {
                            state: rowData
                        })}
                    >
                        اطلاعات سفارش
                    </Button>
                )
            }
        },
        {
            field: null,
            text: "عملیات‌ها",
            element: (rowData) => <OrderActions rowData={rowData} userRole={userRole} />
        }
    ];


    return (
        <DataTablePagination
            tableCols={ordersCols}
            title={"سفارشات"}
            APIFunction={getAllOrdersService}
            dataField={"orders"}
            hasOutlet={true}
            hasCatergory={true}
            categoryOptions={options}
        >
        </DataTablePagination>
    );
}

export default Orders;
